import { styled } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const StyledDataGrid = styled(DataGrid, {
  shouldForwardProp: (prop) => prop !== 'respectHeaderLineBreaks',
})<{ respectHeaderLineBreaks?: boolean }>(({ theme, respectHeaderLineBreaks }) => ({
  ...(respectHeaderLineBreaks && {
    '& .MuiDataGrid-columnHeaderTitle': {
      lineHeight: '1.3',
      whiteSpace: 'pre-line',
    },
  }),
}));

export { StyledDataGrid };
